import { dump } from 'js-yaml'

import { AsyncAPIDefinition, OpenAPI2Definition, OpenAPI3Definition } from '~/portal/types/api.definitions'
import { API_FILE_TYPES } from '~/portal/types/downloadApi'

export const downloadApi = (type: API_FILE_TYPES, definition: OpenAPI2Definition | OpenAPI3Definition | AsyncAPIDefinition, filename: string): void => {
  try {
    const href = `data:text/${type.toLowerCase()};chatset=utf-8,${type === API_FILE_TYPES.JSON ? encodeURIComponent(JSON.stringify(definition)) : encodeURIComponent(dump(definition))}`
    const link = document.createElement('a')
    link.href = href
    link.download = `${filename}.${type.toLowerCase()}`

    link.click()
  } catch {
    //
  }
}
